import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  TAX_SETTINGS_INDEX_REQUESTED,
  TAX_SETTINGS_INDEX_SUCCESS,
  TAX_SETTINGS_INDEX_FAILURE,

  TAX_SETTING_CREATE_REQUESTED,
  TAX_SETTING_CREATE_SUCCESS,
  TAX_SETTING_CREATE_FAILURE,

  TAX_SETTING_UPDATE_REQUESTED,
  TAX_SETTING_UPDATE_SUCCESS,
  TAX_SETTING_UPDATE_FAILURE,

  TAX_SETTING_DELETE_REQUESTED,
  TAX_SETTING_DELETE_SUCCESS,
  TAX_SETTING_DELETE_FAILURE,
} from '../types';

export const taxSettingsIndexRequested = () => {
  return {
    type: TAX_SETTINGS_INDEX_REQUESTED
  }
};

export const taxSettingsIndexSuccess = (taxSettings) => {
  return {
    type: TAX_SETTINGS_INDEX_SUCCESS,
    payload: taxSettings
  }
};

export const taxSettingsIndexFailure = () => {
  return {
    type: TAX_SETTINGS_INDEX_FAILURE
  }
};

export const taxSettingCreateRequested = () => {
  return {
    type: TAX_SETTING_CREATE_REQUESTED
  }
};

export const taxSettingCreateSuccess = (taxSetting) => {
  return {
    type: TAX_SETTING_CREATE_SUCCESS,
    taxSetting: taxSetting
  }
};

export const taxSettingCreateFailure = () => {
  return {
    type: TAX_SETTING_CREATE_FAILURE
  }
};


export const taxSettingUpdateRequested = () => {
  return {
    type: TAX_SETTING_UPDATE_REQUESTED
  }
};

export const taxSettingUpdateSuccess = (taxSetting) => {
  return {
    type: TAX_SETTING_UPDATE_SUCCESS,
    taxSetting: taxSetting
  }
};

export const taxSettingUpdateFailure = () => {
  return {
    type: TAX_SETTING_UPDATE_FAILURE
  }
};

export const taxSettingDeleteRequested = (taxSettingId) => {
  return {
    type: TAX_SETTING_DELETE_REQUESTED,
    taxSettingId: taxSettingId
  }
};

export const taxSettingDeleteSuccess = () => {
  return {
    type: TAX_SETTING_DELETE_SUCCESS
  }
};

export const taxSettingDeleteFailure = () => {
  return {
    type: TAX_SETTING_DELETE_FAILURE
  }
};

export const taxSettingsIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(taxSettingsIndexRequested());

    let endPoint = Config.baseUrl + Config.taxSettings;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(taxSettingsIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(taxSettingsIndexFailure());
      });
  }
}

export const taxSettingCreate = (signedPayload, taxSetting) => {
  return (dispatch) => {
    dispatch(taxSettingCreateRequested());

    let endPoint = Config.baseUrl + Config.taxSetting;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { taxSetting: taxSetting }, { headers: headers })
      .then((response) => {
        dispatch(taxSettingCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(taxSettingCreateFailure());
      });

  }
}

export const taxSettingUpdate = (signedPayload, taxSettingId, taxSetting) => {
  return (dispatch) => {
    dispatch(taxSettingUpdateRequested());

    let endPoint = Config.baseUrl + Config.taxSetting;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { taxSettingId: taxSettingId, taxSetting: taxSetting }, { headers: headers })
      .then((response) => {
        dispatch(taxSettingUpdateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(taxSettingUpdateFailure());
      });

  }
}

export const taxSettingDisable = (signedPayload, taxSettingId) => {
  return (dispatch) => {
    dispatch(taxSettingDeleteRequested(taxSettingId));

    let endPoint = Config.baseUrl + Config.taxSetting + taxSettingId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(taxSettingDeleteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(taxSettingDeleteFailure());
      });
  }
}




